// Global Instructions Rule Applied!

import {
  SetActiveRecordAction,
  UpdateActiveRecordAction,
  RemoveActiveRecordAction,
  RegisterRecordUsageAction,
  UnregisterRecordUsageAction
} from '../../interfaces/active_records.ts'
import {
  SET_ACTIVE_RECORD,
  UPDATE_ACTIVE_RECORD,
  REMOVE_ACTIVE_RECORD,
  REGISTER_RECORD_USAGE,
  UNREGISTER_RECORD_USAGE
} from './constants.ts'

export const setActiveRecord = ({ uuid, record }: { uuid: string; record: any }): SetActiveRecordAction => ({
  type: SET_ACTIVE_RECORD,
  payload: { uuid, record }
})

export const updateActiveRecord = ({
  uuid,
  updates
}: {
  uuid: string
  updates: Record<string, any>
}): UpdateActiveRecordAction => ({
  type: UPDATE_ACTIVE_RECORD,
  payload: { uuid, updates }
})

export const removeActiveRecord = ({ uuid }: { uuid: string }): RemoveActiveRecordAction => ({
  type: REMOVE_ACTIVE_RECORD,
  payload: { uuid }
})

export const registerRecordUsage = ({
  uuid,
  context
}: {
  uuid: string
  context: 'drawer' | 'fullForm'
}): RegisterRecordUsageAction => ({
  type: REGISTER_RECORD_USAGE,
  payload: { uuid, context }
})

export const unregisterRecordUsage = ({
  uuid,
  context
}: {
  uuid: string
  context: 'drawer' | 'fullForm'
}): UnregisterRecordUsageAction => ({
  type: UNREGISTER_RECORD_USAGE,
  payload: { uuid, context }
})
